import {
  HomeIcon,
  ClockIcon,
  ClipboardDocumentCheckIcon,
  BanknotesIcon,
  Bars3Icon,
} from '@heroicons/react/24/outline';

export interface MobileTab {
  id: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  route: string | null; // null = "More" action (opens sidebar)
}

export const MOBILE_TABS: MobileTab[] = [
  { id: 'home', label: 'Home', icon: HomeIcon, route: '/dashboard' },
  { id: 'time', label: 'Time', icon: ClockIcon, route: '/time-entry' },
  { id: 'tasks', label: 'Tasks', icon: ClipboardDocumentCheckIcon, route: '/tasks' },
  { id: 'expenses', label: 'Expenses', icon: BanknotesIcon, route: '/expenses' },
  { id: 'more', label: 'More', icon: Bars3Icon, route: null },
];
